<template>
  <div class="honorBox">
        <img
          v-for="(item, index) in honorUrls"
          :key="index"
          :src="item"
          :class="[honorselect === index ? 'honorActive' : 'honorImg']"
          @click="imghonor(index)"
        />
      </div>
</template>

<script>
export default {
  props:['honorUrls'],
  data(){
    return{
        // 荣誉资质
      honorselect: "", 
    }
},
methods:{
     // 荣誉资质选择放大的照片
    imghonor(index) {
      if (this.honorselect === index) {
        this.honorselect = "";
      } else {
        this.honorselect = index;
      }
    },
}
}
</script>

<style lang="less" scoped>
// 企业荣誉
.honorBox {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  background-color: #104853;
}

.honorImg {
  width: 30%;
  height: 15vh;
  transform: scale(1); /*图片原始大小1倍*/
  transition: all ease 0.5s;
}
.honorImg:last-child:nth-child(3n - 1) {
  margin-right: calc(34.5%);
}
.honorImg:last-child:nth-child(3n - 2) {
  margin-right: calc(67.5%);
}
.honorActive {
  transform: scale(1.5); /*图片需要放大3倍*/
  position: fixed;
  top: 50%;
  left: 0px;
  right: 0px;
  z-index: 100;
  width: 400px;
  height: 300px;
}
.honorBox img {
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.15) 0 0 8px;
  background: #fbfbfb;
  border: 1px solid #ddd;
  margin: 10px auto;
  padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftAside/digital_industry/companyInformation/menu3.vue